import React, { memo } from 'react';
import { useTradingSummaryState } from '~/modules/tradeSheet/tradingSummary/useTradingSummaryState';
import { tradeKeyValueBoxCss, tradeKeyCss, tradeItemCss, tradeValueCss, tradeLabelCss, } from '~/modules/tradeSheet/tradingSummary/tradingSummaryCss';
const TradingFrequency = memo(function TradingFrequency() {
    const { state } = useTradingSummaryState.useContainer();
    const { frequency } = state;
    return (<>
      <p css={tradeLabelCss('#00aab6')}>交易頻率</p>
      <div css={tradeKeyValueBoxCss}>
        <div css={tradeItemCss}>
          <p css={tradeKeyCss}>實際交易日平均交易委託口數：</p>
          <p css={tradeValueCss}>{Number(frequency?.orderingLotFrequency).toFixed(1)}口</p>
        </div>
        <div css={tradeItemCss}>
          <p css={tradeKeyCss}>實際交易日平均交易成交口數：</p>
          <p css={tradeValueCss}>{Number(frequency?.tradingLotFrequency).toFixed(1)}口</p>
        </div>
        <div css={tradeItemCss}>
          <p css={tradeKeyCss}>實際交易日平均交易委託筆數：</p>
          <p css={tradeValueCss}>{Number(frequency?.orderingNumFrequency).toFixed(1)}次</p>
        </div>
        <div css={tradeItemCss}>
          <p css={tradeKeyCss}>實際交易日平均交易成交筆數：</p>
          <p css={tradeValueCss}>{Number(frequency?.tradingNumFrequency).toFixed(1)}次</p>
        </div>
      </div>
    </>);
});
export default TradingFrequency;
